<script lang='js'>
import {
  Doughnut
} from 'vue-chartjs'
export default {
  extends: Doughnut,
  props: {
    labels: {
      type: Array,
      default: () => ['Subscriptions',  'Cancelations']
    },
    values : {
      type: Array
    }
  },
  data () {
    return {
      gradient: null,
      gradient2: null,
      gradient3: null,
    }
  },
  mounted () {
    console.log(this.values);
    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 181)
    this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 300)
    this.gradient3 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 50)
    this.gradient.addColorStop(0, '#14A44D')
    // this.gradient.addColorStop(1, 'rgba(177, 148, 250, 1)')
    this.gradient2.addColorStop(0, '#54B4D3')
    this.gradient3.addColorStop(0, '#FFA500')
    // this.gradient2.addColorStop(1, 'rgba(132, 217, 210, 1)')
    // this.gradient3.addColorStop(0, 'rgba(255, 191, 150, 1)')
    // this.gradient3.addColorStop(1, 'rgba(254, 112, 150, 1)')
    this.renderChart({
      labels: this.labels,
      datasets: [{
        label: 'Revenue',
        data: this.values,
        backgroundColor: [
            this.gradient,
            this.gradient2,
            this.gradient3
          ],
        borderWidth: 0
      }]
    }, {
      responsive: true,
      animation: {
        animateScale: true,
        animateRotate: true
      },
      legend: false
    })
  }
}
</script>

<style scoped lang='scss'>
  .trafficSourceChart {

  }
</style>
